import { Typography } from '@material-ui/core'
import FileSaver from 'file-saver'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import TextField from '@material-ui/core/TextField'
import React, { useState } from 'react'

import pick from 'lodash.pick'

import UserService from '../../services/user.service'
import ModalButtonWrap from '../modal/modalButton'
import { keys, find, omit } from 'lodash'
import constants from '../../constants'
import { createSegment } from '../../store/actions/segments'

import {
  ExportButton,
  BaseForm,
  ExportActions,
  CircularProgress,
  AddButton,
  CancelButton,
} from '../styled'
import { resolveValue } from '../inputs'
import { useSelector, useDispatch } from 'react-redux'

export default function(props) {
  const [open, setOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [searchUsers, setSearchUsers] = useState('all')
  const [colsFilter, setColsFilter] = useState('all')
  const [saveSegmentOpen, setSaveSegmentOpen] = useState(false)
  const [segmentName, setSegmentName] = useState('')
  const dispatch = useDispatch()
  const fields = useSelector(state => state.users.fields)
  const filteredFields = useSelector(state => state.users.filteredFields)
  const users = useSelector(state => state.users.users)
  const filteredUsers = useSelector(state => state.users.filteredUsers)
  const selectedUsers = useSelector(state => state.users.selectedUsers)
  const advancedFilters = useSelector(state => state.users.advancedFilters)
  const buildSegmentFilters = () =>
    advancedFilters.map(f => {
      const field = fields.find(fd => fd.name === f.name)
      let value = f.value
      if (field && Array.isArray(field.values) && field.values.length > 0) {
        const option = field.values.find(v => v.OptionValueID === f.value)
        if (option) value = option.Value
      }
      return { field: f.name, operator: '=', value }
    })

  // segments are evaluated by API on registration form fields only
  const hasReadOnlyFilter = advancedFilters.some(
    f => (fields.find(fd => fd.name === f.name) || {}).readOnly
  )

  const onSaveSegment = () => {
    dispatch(createSegment({ name: segmentName.trim(), search_criteria: { filters: buildSegmentFilters() } }))
    setSaveSegmentOpen(false)
    setSegmentName('')
  }

  const resolveValues = (fields, values) => {
    return keys(values).reduce((acc, k) => {
      const value = values[k];
      const field = find(fields, f => f.name === k);
      const val = resolveValue(field, value);
      return {...acc, [k]:val};
    }, {});
  }

  // Add fake fields to keep in user values ShortUrl and Registered properties
  const fakeEncryptedUrlField = {
    name: 'ShortUrl',
    field_type: 'text'
  };
  const fakeRegiteredField = {
    name: 'Registered',
    field_type: 'text'
  };
  const fieldsEx = [ ...fields, fakeEncryptedUrlField, fakeRegiteredField ];
  const filteredFieldsEx = [ ...filteredFields, fakeEncryptedUrlField, fakeRegiteredField ];

  const numberToLetters = num => {
    let letters = ''
    while (num >= 0) {
        letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[num % 26] + letters
        num = Math.floor(num / 26) - 1
    }
    return letters
}

  const exportUsersToCsv = () => {
    setLoading(true)
    const exportFields = colsFilter === 'all' ? fieldsEx : filteredFieldsEx
    const fieldsName = exportFields.map(field => field.name)
    // columns are exported with their display label, fake fields have no label
    const header = exportFields.reduce((acc, field, i) => {
      acc[numberToLetters(i)] = field.label || field.name
      return acc
    }, {});
    const usersToExport = searchUsers => {
      switch(searchUsers) {
        case 'search': return filteredUsers;
        case 'select': return selectedUsers.map(su => ({id: su.id, values: omit(su, ['id'])}));
        case 'all': return users;
        default: return [];
      }
    }
    UserService.exportToCsv([
      {
        name: 'users',
        content: [
          header,
          ...(usersToExport(searchUsers)).map(user => {
            const userValues = resolveValues(fieldsEx, user.values);
            const values = Object.values(pick(userValues, fieldsName))
            return values.reduce((acc, a, i) => {
              acc[numberToLetters(i)] = a.toString() // Needed for boolean values
              return acc
            }, {})
          })
        ]
      }
    ])
      .then(blob => {
        FileSaver.saveAs(blob, `users_${constants.session.getId()}.xlsx`)
        setLoading(false)
        setOpen(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }

  return (
    <ModalButtonWrap
      onBlur={() => setOpen(false)}
      open={open}
      content={
        <BaseForm>
          <Typography gutterBottom>Souhaitez-vous exporter...</Typography>
          <RadioGroup
            aria-label="Type"
            name="type"
            row
            value={searchUsers}
            onChange={(_, val) => setSearchUsers(val)}
          >
            <FormControlLabel value="all" control={<Radio />} label="Tout" />
            <FormControlLabel
              value="search"
              control={<Radio />}
              label="La recherche en cours"
            />
            <FormControlLabel
              value="select"
              control={<Radio />}
              label="Les lignes sélectionnées"
            />
          </RadioGroup>

          <Typography gutterBottom>
            Sélectionner les colonnes à exporter :
          </Typography>

          <RadioGroup
            aria-label="Type"
            name="type"
            row
            value={colsFilter}
            onChange={(_, val) => setColsFilter(val)}
          >
            <FormControlLabel value="all" control={<Radio />} label="Toutes" />
            <FormControlLabel
              value="search"
              control={<Radio />}
              label="Les colonnes affichées"
            />
          </RadioGroup>

          <ExportActions>
            <ExportButton disabled={loading} onClick={exportUsersToCsv}>
              EXPORTER
              {loading && <CircularProgress size={24} />}
            </ExportButton>
            {searchUsers === 'search' && advancedFilters.length > 0 && !hasReadOnlyFilter && (
              <AddButton onClick={() => setSaveSegmentOpen(true)}>
                EXPORTER VERS UN SEGMENT
              </AddButton>
            )}
          </ExportActions>
          {saveSegmentOpen && (
            <>
              <TextField
                label="Nom du segment"
                value={segmentName}
                onChange={e => setSegmentName(e.target.value)}
                variant="outlined"
                size="small"
                fullWidth
                style={{ marginTop: '12px' }}
              />
              <ExportActions>
                <CancelButton onClick={() => setSaveSegmentOpen(false)}>ANNULER</CancelButton>
                <AddButton disabled={!segmentName.trim()} onClick={onSaveSegment}>ENREGISTRER</AddButton>
              </ExportActions>
            </>
          )}
        </BaseForm>
      }
    >
      <ExportButton onClick={() => setOpen(true)}>
        EXPORTER LA LISTE
      </ExportButton>
    </ModalButtonWrap>
  )
}
